import { Offer } from '@andromeda/polaris-data-access-products';

export default class RetailerOffer {
    public Id: string;

    public ItemId: string;

    public Name: string;

    public Price: string;

    public Image: string;

    public Upc: string;

    constructor(id: string, itemId: string, name: string, price: string, image: string, upc: string) {
        this.Id = id;
        this.ItemId = itemId;
        this.Name = name;
        this.Price = price;
        this.Image = image;
        this.Upc = upc;
    }


    public static FromMercuryOffer(offer: Offer): RetailerOffer {
        return new RetailerOffer(
            offer.id,
            offer.ingredientId,
            offer.name,
            `$${offer.price}`,
            offer.imageUrl,
            offer.upc || '',
        );
    }

    public static CreateDefault() {
        return new RetailerOffer('', '', '', '', '', '');
    }
}
